import React, { Component } from 'react';

import './App.css'
import HeaderContainer from './components/header/HeaderContainer';
import Content from './components/content/Content';
import {
  BrowserRouter
} from "react-router-dom";


class App extends Component {

  constructor(props) {
      super(props);
      this.state = {showNav: true};
  }

  render() {
    return (
      <div id="page">
        <BrowserRouter>
        <div>
          <HeaderContainer />
          <Content />
        </div>
        </BrowserRouter>
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js